// extracted by mini-css-extract-plugin
module.exports = {"container":"_3PU-MQ","singleContent":"_1dzYxA","multiContent":"_39401E","controlLeft":"_3xbGhj","controlRight":"RGeyk8","bottomRightControls":"_3BrZOF"};